import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

export function Footer() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim().toLowerCase();
    if (!q) return;
    setSearchQuery('');
    if (q === 'about' || q === 'about us' || q === 'hakkımızda') {
      navigate(ROUTES.ABOUT);
      return;
    }
    if (q === 'contact' || q === 'contact us' || q === 'iletişim') {
      navigate(ROUTES.CONTACT);
      return;
    }
    if (q === 'news' || q === 'haber') {
      navigate(ROUTES.NEWS);
      return;
    }
    if (q === 'home' || q === 'ana sayfa') {
      navigate(ROUTES.HOME);
      return;
    }
    navigate(`${ROUTES.SEARCH}?q=${encodeURIComponent(searchQuery.trim())}`);
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-info">
          <img src="/9mloh.png" alt="9MM Defence Logo" className="footer-logo" width="100" height="auto" />
          <p>
            Providing advanced defense solutions that meet NATO and global standards.
            From firearms to tactical systems, we deliver reliability, precision, and innovation worldwide.
          </p>
          <div className="search-box" role="search">
            <form onSubmit={handleSearch}>
              <label htmlFor="footer-search" className="sr-only">Search 9mmdefence</label>
              <input
                type="text"
                id="footer-search"
                placeholder="Search 9mmdefence..."
                aria-label="Search 9mmdefence"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" aria-label="Search">
                <i className="fas fa-search" aria-hidden="true" />
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-left">
          <p>© 2025 9MM Defense. All Rights Reserved.</p>
        </div>
        <nav className="footer-links" aria-label="Footer navigation">
          <span>Privacy Policy</span>
          <span>Terms of Service</span>
          <span>Compliance</span>
          <span>Accessibility</span>
        </nav>
      </div>
    </footer>
  );
}
